import { type Skills } from "@/types/types";

export const frontendSkills: Skills[] = [
  {
    id: "e1a2b3c4-5d6e-7f8a-9b0c-1d2e3f4a5b6c",
    name: "HTML5",
    description: "Semantic markup language for structuring modern web content.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    slug: "html5",
    url: "https://developer.mozilla.org/en-US/docs/Web/HTML",
    category: "Markup",
    tags: ["Semantic HTML", "Accessibility", "SEO"],
  },
  {
    id: "f2b3c4d5-6e7f-8a9b-0c1d-2e3f4a5b6c7d",
    name: "CSS3",
    description: "Styling language for responsive layouts and animations.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
    slug: "css3",
    url: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    category: "Styling",
    tags: ["Flexbox", "Grid", "Animations"],
  },
  {
    id: "a3c4d5e6-7f8a-9b0c-1d2e-3f4a5b6c7d8e",
    name: "JavaScript",
    description: "Dynamic scripting language for interactive web development.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    slug: "javascript",
    url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    category: "Language",
    tags: ["ES6+", "Frontend", "DOM"],
  },
  {
    id: "b4c5d6e7-8f9a-0b1c-2d3e-4f5a6b7c8d9f",
    name: "React",
    description: "JavaScript library for building dynamic user interfaces.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    slug: "react",
    url: "https://react.dev",
    category: "Framework",
    tags: ["SPA", "Hooks", "JSX"],
  },
  {
    id: "c5d6e7f8-9a0b-1c2d-3e4f-5a6b7c8d9e0a",
    name: "Next.js",
    description:
      "React framework for SSR, routing, and optimized frontend experiences.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    slug: "nextjs",
    url: "https://nextjs.org",
    category: "Framework",
    tags: ["SSR", "Routing", "Frontend"],
  },
  {
    id: "d6e7f8a9-0b1c-2d3e-4f5a-6b7c8d9e0a1b",
    name: "Tailwind CSS",
    description: "Utility-first CSS framework for rapid UI development.",
    image:
      "https://static.cdnlogo.com/logos/t/58/tailwind-css.svg",
    slug: "tailwind",
    url: "https://tailwindcss.com",
    category: "Styling",
    tags: ["Utility-first", "Responsive", "Dark Mode"],
  },
  {
    id: "e7f8a9b0-1c2d-3e4f-5a6b-7c8d9e0a1b2c",
    name: "Bootstrap",
    description: "CSS framework for responsive and mobile-first web design.",
    image:
      "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
    slug: "bootstrap",
    url: "https://getbootstrap.com",
    category: "Styling",
    tags: ["Responsive", "Components", "Grid System"],
  },
];

export const backendSkills: Skills[] = [
  {
    id: "f8a9b0c1-2d3e-4f5a-6b7c-8d9e0a1b2c3d",
    name: "Node.js",
    description: "JavaScript runtime for backend and full-stack development.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    slug: "nodejs",
    url: "https://nodejs.org",
    category: "Backend",
    tags: ["API Development", "Server-side", "Next.js"],
  },
];

export const tools: Skills[] = [
  {
    id: "a9b0c1d2-3e4f-5a6b-7c8d-9e0a1b2c3d4e",
    name: "TypeScript",
    description: "Superset of JavaScript for type-safe, scalable applications.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    slug: "typescript",
    url: "https://www.typescriptlang.org",
    category: "Language",
    tags: ["Type Safety", "React", "Next.js"],
  },
  {
    id: "b0c1d2e3-4f5a-6b7c-8d9e-0a1b2c3d4e5f",
    name: "Git",
    description: "Distributed version control system for tracking changes in source code and collaboration.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    slug: "git",
    url: "https://git-scm.com",
    category: "Tools",
    tags: ["Version Control", "Collaboration", "GitHub", "Open Source"],
  },
  {
    id: "c1d2e3f4-5a6b-7c8d-9e0a-1b2c3d4e5f0a",
    name: "VS Code",
    description: "IntelliJ-based code editor for JavaScript and TypeScript.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
    slug: "vscode",
    url: "https://code.visualstudio.com",
    category: "Tools",
    tags: ["Code Editor", "JavaScript", "TypeScript"],
  },
  {
    id: "d2e3f4a5-6b7c-8d9e-0a1b-2c3d4e5f0a1b",
    name: "Postman",
    description: "API testing and documentation tool for RESTful web APIs.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
    slug: "postman",
    url: "https://www.postman.com",
    category: "Tools",
    tags: ["API Testing", "Documentation", "RESTful APIs"],
  },
  {
    id: "e3f4a5b6-7c8d-9e0a-1b2c-3d4e5f0a1b2c",
    name: "Docker",
    description: "Containerization platform for deploying applications.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    slug: "docker",
    url: "https://www.docker.com",
    category: "Tools",
    tags: ["Containerization", "Microservices", "DevOps"],
  },
  {
    id: "f4a5b6c7-8d9e-0a1b-2c3d-4e5f0a1b2c3d",
    name: "Heroku",
    description: "Platform as a Service (PaaS) for deploying web apps.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-original.svg",
    slug: "heroku",
    url: "https://www.heroku.com",
    category: "Tools",
    tags: ["Deployment", "Cloud Hosting", "DevOps"],
  },
  {
    id: "a5b6c7d8-9e0a-1b2c-3d4e-5f0a1b2c3d4e",
    name: "Netlify",
    description: "Static site generator and platform for deploying web apps.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/netlify/netlify-original.svg",
    slug: "netlify",
    url: "https://www.netlify.com",
    category: "Tools",
    tags: ["Static Site Generation", "Deployment", "DevOps"],
  },
  {
    id: "b6c7d8e9-0a1b-2c3d-4e5f-0a1b2c3d4e5f",
    name: "GitHub",
    description: "Version control and collaboration platform for software projects.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    slug: "github",
    url: "https://github.com",
    category: "Tools",
    tags: ["Version Control", "Collaboration", "Open Source"],
  },
  {
    id: "c7d8e9f0-1a2b-3c4d-5e6f-0a1b2c3d4e6a",
    name: "Figma",
    description: "Collaborative design tool for UI/UX prototyping and wireframing.",
    image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    slug: "figma",
    url: "https://www.figma.com",
    category: "Design",
    tags: ["UI/UX", "Prototyping", "Wireframing"],
  },
];
